'use strict';

import '@auth0/auth0-spa-js';
import 'angular-auth0-spa-js';
import { environment } from '@quartz-gov-legacy/environments/environment';
import { MonitoringUtils } from '@quartz-gov-legacy/app/monitoring/monitoringUtils';

var appMain = angular.module('app.main', [
    // Angular Core
    'ngAnimate',
    'ngSanitize',
	  'ngAria',

    // Third Party
    'auth0.auth0',
    'angularMoment',
    'hljs',
    'ui.router',
    'ui.select',
    'ui.bootstrap',
    'ng-sortable',
    'angular-growl',
    'angular.filter',
    'angularFileUpload',
    'ngclipboard',
    'xeditable',
    'mgcrea.ngStrap.datepicker',
    'mgcrea.ngStrap.popover',
    'mgcrea.ngStrap.modal',
    'textAngular',
    'material.components.autocomplete',
    'material.components.button',
    'material.components.chips',
    'material.components.icon',
    'material.components.input',
    'material.components.list',
    'material.components.radioButton',
    'material.components.switch',
    'material.components.select',
    'material.components.slider',
    'material.components.menu',
    'material.components.menuBar',
    'material.components.tabs',
    'material.components.toolbar',
    'material.components.tooltip',
    'material.components.toast',
    'material.components.progressCircular',
    'SignalR',
    'hc.marked',

    // Helpers
    'helpers.mail',

    // do not move.  must load before any route configs.
    'helpers.routeDecorator',

    // Filters
    'gov.filters',

    // Services
    'gov.services',
    'services.auth',
    'services.grcCrontab',

    // Shared Modules
    'actionPlanModule',
    'actionPlanCriteriaModule',
    'controlModule',
    'committeeModule',
    'glossaryTermModule',
    'personModule',
    'planInitiativeModule',
    'riskModule',
    'riskEventModule',
    'searchModule',
    'pointsOfFocusModule',
    'cacmModule',
    'oddModule',
    'followUpModule',
    'procedureModule',
    'businessUnitModule',
    'auditMandateEditModule',
    'businessPlanModule',
    'bcmModule',
    'iamSystemModule',
  	'itemTaskModule',

    // Controllers
    'AuthenticationControllers',
    'navigationControllers',
    'languageControllers',

    // Directives
    'gov.directives',
    'directives.attachmentImg',
    'directives.boxFormDirty',
    'directives.confirmClickDirective',
    'directives.editInPlace',
    'directives.fallback',
    'directives.focusOn',
    'directives.govAutoFocus',
    'directives.GOVContact',
    'directives.GOVHistoryCtxt',
    'directives.placeholder',
    'directives.selectPerson',
    'directives.textareaRead',
    'directives.TopBar',
    'directives.govClosedTag',
    'directives.govSyncHeight',
    'directives.pointsOfFocus',
    'directives.numbersOnly',
    'directives.oddPlaceholder',
    'directives.oddMaxLength',
    'directives.oddMinNumber',
    'directives.oddMaxNumber',
    'directives.sidebarHelper',
    'directives.uiRouter',
    'directives.govBreadcrumb',
    'directives.highlightOverlay',
    'directives.translate',
    'directives.scrollTop',

    'services.authenticatedUser',

    'appMain.Config',

    // Features
    'auditMandateRoutes',
    'adminRoutes',
    'adminGovernanceProcessRoutes',
    'aricRoutes',
    'aricCertificationRoutes',
    'businessPlanExplorerRoutes',
    'grcEditRoutes',
    'homeRoutes',
    'riskSelfAssessmentListRoutes',
    'riskSelfAssessmentReviewRoutes',
    'riskSelfAssessmentAssessRoutes',
    'searchRoutes',
    'staticHtmlPageRoutes',
    'surveyRoutes',
    'visualGuidelinesRoutes',
    'cacmRoutes',
    'searchV2Module',
    //'searchFacetsModule',
    //'searchPagingModule',
    'signalrRoutes',
    'businessPlanningModule',
    'initiativeUpdateStatusRoutes',
    'campaignMgmtRoutes',
    'externalPartyEditRoutes',
    'oddQuestionnaireTemplatesEditRoutes',
    'recomRoutes',
    'recomActionPlanUpdateStatusRoutes',
    'surveyCampaignsRoutes',
    'procedureRoutes',
    'bcmRoutes',
]);

// Defines the default delay to display notifications. This value is overridden during tests to speed them up
appMain.value('govNotificationDelay', 5000);

appMain.config(['$provide', '$locationProvider', function ($provide, $locationProvider) {
  // Remove the ! from the hash so that
  // auth0.js can properly parse it
  $locationProvider.hashPrefix('');

  $locationProvider.html5Mode(true);
}]);

appMain.controller('AppCtrlMain', function () {
});

appMain.config(['$compileProvider', function ($compileProvider) {
    $compileProvider.debugInfoEnabled(false);
}]);

appMain.config(['$sceDelegateProvider', function ($sceDelegateProvider) {
  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    `${environment.apiUrl}/**`
  ]);
}]);

// Forward AngularJS uncaught exceptions to Sentry. The library's window-level handler
// catches synchronous errors, but AngularJS swallows controller/digest errors via its
// own $exceptionHandler — without this decorator they never reach Sentry.
appMain.factory('$exceptionHandler', ['$log', function ($log) {
  return function (exception, cause) {
    $log.error.apply($log, arguments);
    MonitoringUtils.captureException(exception);
  };
}]);

// For Questionnaire Templates
appMain.constant('CAMPAIGN_TYPE', {
    ODD: 'ODD',
    SURVEY: 'SURVEYV2'
});

appMain.factory('SmartCacheInterceptor', ['$q', 'mainVersion', function ($q, mainVersion) {
    return {
        request: function (config) {
            if (config.url.indexOf(".tpl.html") > -1) {
                var separator = config.url.indexOf("?") === -1 ? "?" : "&";
                config.url = config.url + separator + "v=" + mainVersion;
            }
            return config || $q.when(config);
        }
    };
}]);

appMain.directive('animateOnLoad', ['$timeout', function ($timeout) {
    return {
        'link': function (scope, element) {
            $timeout(function () {
                element.addClass('loaded');
            });
        }
    };
}]);

appMain.factory('GOVPermissionsInterceptor', ['$q', 'mainVersion', '$rootScope', function ($q, mainVersion, $rootScope) {
    return {
        response: function (response) {
            // Check GOV Permissions
            var perms = response.headers('GOV-Permissions');
            if (perms) {
                response.data = response.data ? response.data : {};
                response.data._GOV = {};

                if (perms.length > 0) {
                    _.each(perms.split(','), function (perm) {
                        response.data._GOV[perm.trim()] = true;
                    });
                }
            }

            // Check API version change
            var govVersion = response.headers('GOV-Version');
            if (govVersion && mainVersion && mainVersion !== govVersion && !appMain._govVersionChanged) {
                // Display notification to user
                $rootScope.showApplicationOutdated = true;
                appMain._govVersionChanged = true;
            }

            return response;
        },

        responseError: function (rejection) {
            // needs to manually opt out of errors
            // Show errors instead of hiding them - 05/01/17
            if (rejection.status >= 400 && rejection.status < 500 && rejection.config.ignoreError) {
                rejection.data = '';
                rejection.error = true;
                return rejection;
            }

            return $q.reject(rejection);
        }
    }
}]);

appMain.config(['growlProvider', '$httpProvider', function (growlProvider, $httpProvider) {
    growlProvider.globalEnableHtml(true);
    growlProvider.globalTimeToLive(20000);

    var serverMessageInterceptor = ['$q', 'growl', function ($q, growl) {
        var _messagesKey = "GrowlMessages";

        function checkResponse(response) {
            if (response && response.data[_messagesKey] && response.data[_messagesKey].length > 0) {
                growl.addServerMessages(response.data[_messagesKey]);
            }
        }

        function success(response) {
            checkResponse(response);
            return response;
        }

        function error(response) {
            if (response.config && response.config.timeout) {
                return $q.reject(response);
            }

            checkResponse(response);
            return $q.reject(response);
        }

        return function (promise) {
            return promise.then(success, error);
        };
    }];

    var errorInterceptor = ['$q', '$injector', function ($q, $injector) {
        return {
            'responseError': function (rejection) {
                if (rejection.config && rejection.config.timeout && !rejection.config.status) {
                    return $q.reject(rejection);
                }

                var message = rejection.data?.Message || rejection.data?.message || rejection.statusText;
                var toastr;

                function getToaster() {
                    if (!toastr) {
                        toastr = $injector.get('$mdToast');
                    }
                    return toastr;
                }

                getToaster().show(
                     getToaster()
                         .simple()
                         .content(message)
                         .position('top right')
                         .hideDelay($injector.get('govNotificationDelay'))
                         .action('OK')
                         .theme('danger')
                );
                window.scrollTo(0, 0);

                return $q.reject(rejection);
            }
        }
    }];

    $httpProvider.interceptors.push(serverMessageInterceptor);
    $httpProvider.interceptors.push(errorInterceptor);
    // $httpProvider.interceptors.push('SmartCacheInterceptor');
    $httpProvider.interceptors.push('GOVPermissionsInterceptor');
}]);

appMain.config(['$mdThemingProvider', function ($mdThemingProvider) {
    $mdThemingProvider.theme('primary');
    $mdThemingProvider.theme('danger');

    // Extend the red theme with a few different colors
    var customRed = $mdThemingProvider.extendPalette('red', {
        '500': 'dd2c00' // based on @color-error in variables.less
    });
    // Register the new color palette map with the name <code>neonRed</code>
    $mdThemingProvider.definePalette('red', customRed);

    // Use that theme for the primary intentions
    $mdThemingProvider.theme('default').warnPalette('red');
}]);

appMain.config(['$datepickerProvider', function ($datepickerProvider) {
    angular.extend($datepickerProvider.defaults, {
        dateFormat: 'fullDate',
        autoclose: true,
        startWeek: 1,
        iconLeft: 'fa fa-chevron-left pane-nav',
        iconRight: 'fa fa-chevron-right pane-nav'
    });
}]);


appMain.config(['markedProvider', function (markedProvider) {
    markedProvider.setOptions({gfm: true, breaks: true, sanitize: true});
}]);

// Available on 1.4+
//appMain.config(['$ariaProvider', function ($ariaProvider) {
//    $ariaProvider.config({
//        bindRoleForClick: true
//    });
//}]);

//appMain.config(['$urlRouterProvider', function ($urlRouterProvider) {

//    $urlRouterProvider.rule(function ($injector, $location) {
//        //var path = $location.url();
//        //var normalized = path.toLowerCase();

//        ////if (!(path[path.length - 1] === '/' || path.indexOf('/?') > -1)) {
//        ////    if (normalized.indexOf('?') > -1) {
//        ////        normalized = normalized.replace('?', '/?');
//        ////    } else {
//        ////        normalized = normalized + '/';
//        ////    }

//        ////}

//        //if (path != normalized)
//        //{
//        //    $location.replace().path(normalized);
//        //}
//    });
//}]);

appMain.config(
  ['$injector', '$httpProvider', 'angularAuth0Provider',
  function ($injector, $httpProvider, angularAuth0Provider) {
    // Conditionally initialize Auth0 if using Auth0 authentication
    var authProvider = environment.authProvider || 'auth0';

    if (authProvider === 'auth0') {
      angularAuth0Provider.init({
        audience: environment.auth.audience,
        cacheLocation: 'localstorage',
        client_id: environment.auth.clientID,
        connection: environment.auth.connection,
        domain: environment.auth.domain,
        redirect_uri: environment.auth.redirect || window.location.origin,
        useRefreshTokens: true,
        httpInterceptor: {
          allowedList: [
            {
              uri: `${environment.apiUrl}/*`,
            },
          ],
        },
      });
    }
}]);

appMain.factory('httpRequestInterceptor', ['angularAuth0', function (angularAuth0) {
  return {
    request: function (config) {
      return angularAuth0.getTokenSilently()
        .then(function(accessToken) {
          config.headers['Authorization'] = `Bearer ${accessToken}`;

          return config;
        });
    }
  };
}]);

appMain.config(['$httpProvider', function ($httpProvider) {
  var authProvider = environment.authProvider || 'auth0';

  if (authProvider === 'auth0') {
    $httpProvider.interceptors.push('httpRequestInterceptor');
  } else if (authProvider === 'keycloak') {
    $httpProvider.interceptors.push('keycloakInterceptor');
  }
}]);

appMain.config(['$httpProvider', '$provide', function ($httpProvider, $provide) {
    // Initialize get if not there
    if (!$httpProvider.defaults.headers.get) {
        $httpProvider.defaults.headers.get = {};
    }

    // Enables Request.IsAjaxRequest() in ASP.NET MVC
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

    // Disable IE ajax request caching
    $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
}]);

appMain.run(['editableOptions', 'languageService', function (editableOptions, languageService) {
    editableOptions.theme = 'bs3';
    languageService.initializeLanguage();
}]);

// angular.module('appMain.Config', []).constant('mainVersion', '@templateVersion');
angular.module('appMain.Config', []).constant('mainVersion', '1');

// first config loaded. must load before any routes.
angular.module('helpers.routeDecorator', []).config(['$stateProvider', function ($stateProvider) {
    // "resolve" doesn't have a decorator. Using an alternative method to decorate "resolve"
    // see https://github.com/angular-ui/ui-router/issues/1165
    $stateProvider.decorator('path', function(state, parentFn) {
        if (state.self.resolve === undefined) {
            state.self.resolve = {};
            state.resolve = state.self.resolve;
        }

        // resolve authenticatedUser on all states
        state.resolve.authenticatedUser = ['$rootScope', 'authenticatedUserService', function($rootScope, authenticatedUserService) {
            return authenticatedUserService.getAuthenticatedUser().then(function(authenticatedUser) {
                $rootScope.authenticatedUser = authenticatedUser;

                return authenticatedUser;
            });
        }];

        // copy permissions (featureRole, key, permission) from data to resolve.
        if (state.data && state.data.permissions && !state.resolve.permissions) {
            state.resolve.permissions = function() { return state.data.permissions };
        }

        // resolve permissions on all states (block route if permission is not found)
        if (state.resolve.permissions) {
            state.resolve.hasPermission = [
                         '$q', 'permissionService', 'permissions', 'authenticatedUser',
                function ($q, permissionService, permissions, authenticatedUser) {
                    /* /!\ required for resolve racing (make sure authenticatedUser is set to $rootscope) */
                    if (!permissionService.hasPermissions(permissions)) {
                        // can't change route in 'resolve' function. must redirect on $stateChangeError event
                        return $q.reject({ status: 403 });
                    }
            }];
        }

        return parentFn(state);
    });
}]);

appMain.run(['$rootScope', '$state', 'authService', function ($rootScope, $state, authService) {
    $rootScope.$on('$stateChangeError', function(evt, to, toParams, from, fromParams, error) {
        if (error.status === 403) {
            if ($rootScope.authenticatedUser) {
                $state.go('home', { UserItemPersonID: $rootScope.authenticatedUser.MetaDataUser.ItemPersonID }, {location: 'replace'});
            } else {
                $state.go('home');
            }
        }
    });
}]);

appMain.run(['$anchorScroll', function($anchorScroll) {
    $anchorScroll.yOffset = 10;   // always scroll by 10 extra pixels
}]);

appMain.run(['$rootScope', '$window', 'authService', function ($rootScope, $window, authService) {
  // Fix OAuth callback URL mangled by AngularJS html5Mode.
  // When Keycloak redirects with /#state=...&code=..., AngularJS html5Mode
  // rewrites the hash fragment into a path like /state=...&code=...
  // We detect this and reconstruct the proper hash-based URL.
  var pathname = $window.location.pathname;
  var hasOAuthCallback = pathname.indexOf('state=') !== -1 && pathname.indexOf('code=') !== -1;
  var hasOAuthError = pathname.indexOf('error=') !== -1 && pathname.indexOf('state=') !== -1;

  if (hasOAuthCallback || hasOAuthError) {
    var oauthParams = pathname.substring(1);
    var fixedUrl = $window.location.origin + '/#' + oauthParams;
    $window.history.replaceState({}, '', fixedUrl);
  }

  // Detect Keycloak error responses (check-sso found no session)
  var hash = $window.location.hash;
  var forceLogin = false;

  if (hash && hash.indexOf('error=login_required') !== -1) {
    forceLogin = true;
    $window.history.replaceState({}, '', $window.location.pathname + $window.location.search);
  }

  // Handle post-logout redirect (?logged_out=true from Keycloak logout)
  var urlParams = new URLSearchParams($window.location.search);
  var postLogout = urlParams.has('logged_out');

  if (postLogout) {
    urlParams.delete('logged_out');
    var cleanUrl = $window.location.pathname;
    if (urlParams.toString()) {
      cleanUrl += '?' + urlParams.toString();
    }
    $window.history.replaceState({}, '', cleanUrl);
    forceLogin = true;
  }

  // Initialize the authentication provider (Auth0 or Keycloak)
  authService.init({ forceLogin: forceLogin })
    .then(function() {
      return authService.handleAuthentication();
    })
    .then(function(targetRoute) {
      return authService.isAuthenticated()
        .then(function(isAuthenticated) {
          if (!isAuthenticated) {
            var currentRoute = $window.location.pathname + $window.location.search;
            authService.login(targetRoute || currentRoute);
          } else if (targetRoute) {
            $window.location.href = targetRoute;
          }
        });
    })
    .catch(function() {
      // keycloakProvider's init catch already logged structured details + state snapshot.
      // Re-logging `error` here would just print `undefined` in the same failure modes,
      // which is actively misleading when triaging user reports.
      console.warn('[app.run] Auth initialization chain failed — attempting login redirect');
      var currentRoute = $window.location.pathname + $window.location.search;
      authService.login(currentRoute);
    });
}]);

/*===> Uncomment to debug ui-router
appMain.run(function ($rootScope, $state) {
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    console.log('$stateChangeStart to ' + toState.to + '- fired when the transition begins. toState,toParams : \n', toState, toParams);
  });

  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams) {
    console.log('$stateChangeError - fired when an error occurs during transition.');
    console.log(arguments);
  });

  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
    console.log('$stateChangeSuccess to ' + toState.name + '- fired once the state transition is complete.');
  });

  $rootScope.$on('$viewContentLoaded', function (event) {
    console.log('$viewContentLoaded - fired after dom rendered', event);
  });

  $rootScope.$on('$stateNotFound', function (event, unfoundState, fromState, fromParams) {
    console.log('$stateNotFound ' + unfoundState.to + '  - fired when a state cannot be found by its name.');
    console.log(unfoundState, fromState, fromParams);
  });
});*/

// allow to redirect to the new GOV
appMain.run(['$rootScope', '$window', function ($rootScope, $window) {
    $rootScope.$on('$stateChangeStart',
        function (event, toState, toParams) {
            if (toState.sendToGovNew) {
                event.preventDefault();
                var url = environment.govUrl + toState.url;

                _.forOwn(toParams, function(val, key) {
                    if (url.indexOf('{' + key + '}') >= 0) {
                        // Replace '{key}' with the value
                        url = url.replace('{' + key + '}', val)
                    } else if (val) {
                        // Otherwise replace 'key' with 'key=val'
                        url = url.replace(key, key + '=' + encodeURIComponent(val));
                    } else {
                        // Else remove key from url
                        url = url.replace(key, '');
                    }
                });
                $window.open(url, '_self');
            }
        });
}]);
